import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ThreeDots } from "react-loader-spinner";
import _ from "lodash"
import { v4 as uuid } from "uuid";

import { FileUpload } from "primereact/fileupload";
import { DropDownField, Button, CalendarField } from "../../../helpers";
import Product from "./Product";
import SellerSearch from "../../../common/SellerSearch";

import "../index.css"

import { gstCalculation, round, totalPriceCalculation, validateInputs } from "../../../utils";
import { PettyCashExpenseSchema, PettyCashTransactionSchema, pettyCashTransactionDetails } from "../../../validation/pettyCashValidation";

import { getSellerSearch } from "../../../services/api/pettyCash";

import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { fetchStates } from "../../../services/redux/reducers/commonThunk";
import { uploadFile } from "../../../services/api/company";
import { postPettyCashExpense, getUOMs} from "../../../services/api/pettyCash";
import { getPettyCashCategories } from "../../../services/api/pettyCashCategoties";
import { getCompanyBillAddrs } from "../../../services/api/companyBillAddr";
import Loading from "../../../common/Loading";
import { getPMCompanyConfig } from "../../../setup/pmCompanyConfig";


const initialProduct = {
	id: uuid(),
	pettyCashCategoryId: "",
	prodDesc: "",
	unit: 0,
	HSNCode: 0,
	TDS: 0,
	unitPrice: 0,
	quantity: 0,
	CGST: 0,
	SGST: 0,
	IGST: 0,
	disabled : true,
	isDocNoMandatory: false
}

const AddExpense = (props) => {
	const { pettyCashAccount, getPettyCashData, setVisibleAddExpense, productsList, setProductsList, transactionDetails, setTransactionDetails } = props

	const [visibleAssignseller, setVisibleAssignSeller] = useState(false);
	const [isIGST, setIsIGST] = useState(true)
	const [pettyCashCategories, setPettyCashCategories] = useState([])
	const [documents, setDocuments] = useState([])
	const [UOMData, setUOMData] = useState([])
	const [sellerData , setSellerData] = useState({})
	const [statesData, setStatesData] = useState([])
	const [productErrors, setProductErrors] = useState({})
	const [formErrors , setFormErrors] = useState({})
	const [isLoading, setIsLoading] = useState(false)
	const [procmartCompanyBillAddrs, setProcmartCompanyBillAddrs] = useState([])
	const [sellerSuggestions, setSellerSuggestions] = useState([])

	const dispatch = useDispatch()
	const usersData = useSelector(state => state.userDetails)
	const pmCompanyDetails = useSelector((state) => state.userDetails.PMCompanyDetails)
	const statesDetails = useSelector((state) => state.common.states)

	const pmCompanyConfig = getPMCompanyConfig(usersData.PMCompanyDetails.companyId)

	let total = totalPriceCalculation(productsList)
	
	useEffect(() => {
		fetchPettyCashCategoryData()
		fetchRecommendedSeller()
		dispatch(fetchStates())
	},[])

	useEffect(() => {
		getProcmartStates()
	}, [statesDetails])

	const fetchRecommendedSeller = async () => {
		const data = { emailId: 'vouchers@procmart.com' }

		setIsLoading(true)
        const response = await getSellerSearch(data)
		setIsLoading(false)

        if(response.failure){
            dispatch(raiseToast({ severity: 'error', summary: "Recommended seller", detail: response.data.error }))
        }else{
			setSellerSuggestions(response)
        }
	}

	const getProcmartStates = async () => {
		let updatedCompanyBranches = []
		pmCompanyDetails.companyBranches?.map(eachCompanyBranch => {
			const relatedUserRoleBranch = usersData?.rolesList?.find(eachRole => eachRole?.branchId === eachCompanyBranch?.branchId)
			if (relatedUserRoleBranch?.branchId){
				updatedCompanyBranches.push(eachCompanyBranch)
			}
		})

		const isCompanyLevelUser = usersData?.rolesList?.some(eachRole => eachRole?.branchId === 0)
		if (isCompanyLevelUser){
			updatedCompanyBranches = pmCompanyDetails.companyBranches
			setTransactionDetails(prevState => ({...prevState, PMState: pmCompanyConfig.defaultStateId}))
		}

        const allPrimaryBillAddrId =  _.map(updatedCompanyBranches, 'primaryBillAddrId')
        const response = await getCompanyBillAddrs({ billAddrIds: allPrimaryBillAddrId, paginator: false })

        if(response.failure){
            dispatch(raiseToast({severity:'error', summary: 'Billing Address', detail: response.data.error , life: 3000}))
        }
        // console.log('com bill', response.data.data)
        setProcmartCompanyBillAddrs(response.data.data)

        const allStateIds = _.map(response.data.data, 'stateId')
		// console.log("allstates", allStateIds)
        const filteredStates = _.filter(statesDetails, (state) => allStateIds.includes(state.stateId))
        // console.log("filtered states",filteredStates)

        setStatesData(filteredStates)
		if(filteredStates.length === 1){
			setTransactionDetails(prevState => ({...prevState, PMState : filteredStates[0].stateId }))
		}
    }

	const fetchPettyCashCategoryData = async () => {
		const response = await getPettyCashCategories()
		const UOMData = await getUOMs()
		setUOMData(UOMData)
		setPettyCashCategories(response.data)

	}

	const handleOnAddExpense = async () => {
		let updatedProductsList = productsList.map(eachProduct => {
			if (pmCompanyConfig.defaultHSNCode){
				eachProduct.HSNCode = pmCompanyConfig.defaultHSNCode
			}
			return {...eachProduct, 
				pettyCashCategoryId: eachProduct.pettyCashCategoryId?.pettyCashCategoryId ? eachProduct.pettyCashCategoryId?.pettyCashCategoryId : "", 
				unit: eachProduct.unit ? eachProduct.unit.materialUOMId : null,
				docType: eachProduct.pettyCashCategoryId?.pettyCashCategoryId ? eachProduct.pettyCashCategoryId?.docType : null
			}
		})

		const validation_res = await validateInputs(PettyCashExpenseSchema, updatedProductsList)
		const validation_res_2 = await validateInputs(PettyCashTransactionSchema, transactionDetails)
		if (validation_res  || validation_res_2){
			console.log(validation_res, validation_res_2)
			if (validation_res_2.error && validation_res.error){
				setFormErrors(validation_res_2.error)
				setProductErrors(validation_res.error)
			} 
			else if (validation_res_2.error  && !validation_res.error) {
				setFormErrors(validation_res_2.error)
				setProductErrors({})
			}
			else if (!validation_res_2.error && validation_res.error) {
				setFormErrors({})
				setProductErrors(validation_res.error)
			} else {
				setProductErrors({})
				setFormErrors({})
				updatedProductsList.map((eachProduct) => {
					const eachCalculation = gstCalculation(eachProduct)
					eachProduct.totalAmountBeforeTax = round(eachCalculation.taxBeforePrice)
					eachProduct.totalAmountWithTax = round(eachCalculation.totalPrice)
					eachProduct.createdBy = usersData?.userId
					eachProduct.updatedBy = usersData?.userId
					return eachProduct
				})

				if (transactionDetails?.documentType !== "VOUCHER"){
					if(transactionDetails?.documentPath?.length === 0){
						return dispatch(raiseToast({severity:'error', detail:'Please Upload the Document', life: 3000}))
					}
				}

				if (!sellerData?.userId){
					return dispatch(raiseToast({severity:'error', detail:'Please assign seller', life: 3000}))
				}
				let pettyCashData = {
					productsList : updatedProductsList,
					data: {
						PMState : transactionDetails.PMState,
						entryType : transactionDetails.pettyCashType,
						amount : round(total),
						transactionDate : transactionDetails.transactionDate,
						statusId : 1,
						sellerId : sellerData?.userId,
						documentType : transactionDetails.documentType,
						documentPath : transactionDetails.documentPath?.length ? transactionDetails.documentPath : null,
						// voucherNo: 1,
						pettyCashAccount : pettyCashAccount?.pettyCashAccountId,
						createdBy: usersData?.userId,
						updatedBy: usersData?.userId,
						pmCompanyId: pmCompanyDetails.pmCompanyId
					}
				}
				if (window.confirm("Are you sure you want to continue...?")){
					setIsLoading(true)
					const response = await postPettyCashExpense(pettyCashData)
					if (response?.failure){
						dispatch(raiseToast({severity:'error', summary: response.data.error, detail:'Petty Cash Expense is Not Inserted', life: 3000}))
					} else {
						setVisibleAddExpense(false)
						dispatch(raiseToast({severity:'success', summary: "Success", detail:'Petty Cash Expense is Inserted', life: 3000}))
						getPettyCashData()
						setProductsList([])
						setTransactionDetails(pettyCashTransactionDetails)
						setSellerData({})
					}
					setIsLoading(false)
				}
			}
		}
	}

	const fileUploadHandler = ({ files, options }, doc_name) => {
        const [file] = files;
        const fileReader = new FileReader();
		if(file.size > 5242880){
			options.clear()
			return dispatch(raiseToast({severity:'error', summary: "Upload File", detail: 'File size exceeds 5MB', life: 3000}))
		}
        fileReader.onload = (e) => {
            uploadExpenseRelatedCertificates(doc_name, file.name, e.target.result,options.props.name);
        }
        fileReader.readAsDataURL(file);
		
        options.clear()
    }

	const uploadExpenseRelatedCertificates = async (doc_name, file_name, data_uri, input_name) => {
        let data = {
            doc_name,
            file_name,
            data_uri
        }
		
        let response = await uploadFile(data)

        console.log("upload-file-response", response)
        if (response) {
            // transactionDetails["documentPath"] = response.data
            // setTransactionDetails({ ...transactionDetails })
			let updatedDoc = [...transactionDetails?.documentPath, response.data]
			let updatedTransactionDetails = {...transactionDetails, "documentPath": updatedDoc}
			setTransactionDetails(updatedTransactionDetails)
			setDocuments(prevState => [...prevState, response.data])
        } else{
			console.log("error")
		}
    }

	const removeExpenseRelatedCertificates = (event, certificateName, docString) => {
        event.stopPropagation();
		let updatedDocuments = documents?.filter(eachDoc => eachDoc !== docString)
        setDocuments(updatedDocuments)
        delete transactionDetails[certificateName]
        setTransactionDetails({ ...transactionDetails, documentPath: updatedDocuments })
    }

	const pettyCashTypeData = [
		{ value: "EXPENSE-CASH", label: "CASH" },
		{ value: "EXPENSE-CARD", label: "CARD" }
	]

	const documentTypeData = [
		{ label: "VOUCHER", value: "VOUCHER" },
		{ label: "TAX-INVOICE", value: "TAX-INVOICE" },
		{ label: "VOUCHER-INVOICE", value: "VOUCHER-INVOICE" }
	]

	const handleChange = async (e) => {
		if (e.target.name === "documentType"){
			if (e.target.value === "TAX-INVOICE"){
				const updatedProductsList = productsList?.map(eachProduct => {
					return {...eachProduct, disabled : false, IGST : 0, CGST : 0, SGST : 0}
				})
				setProductsList(updatedProductsList)
			}else{
				const updatedProductsList = productsList?.map(eachProduct => {
					return {...eachProduct, disabled : true, IGST : 0, CGST : 0, SGST : 0}
				})
				setProductsList(updatedProductsList)
				setTransactionDetails(prevState => ({...prevState, "documentPath" : []}))
			}
		}else {
			const updatedProductsList = productsList?.map(eachProduct => {
				return {...eachProduct}
			})
			setProductsList(updatedProductsList)
		}
        setTransactionDetails(prevState => ({...prevState, [e.target.name] : e.target.value}))
    }

	const handleOnAddSeller = (id, data) => {
		
		data.map(eachSeller => {
			if (eachSeller.id === id){
				setVisibleAssignSeller(false)
				// if (eachSeller.stateId === transactionDetails?.PMState){
				// 	const updatedProductsList = productsList?.map(eachProduct => {
				// 		return {...eachProduct, cgstDisabled : false, igstDisabled: true, IGST : 0}
				// 	})
				// 	setProductsList(updatedProductsList)
				// }else {
				// 	const updatedProductsList = productsList?.map(eachProduct => {
				// 		return {...eachProduct, cgstDisabled : true, igstDisabled: false, CGST : 0, SGST : 0}
				// 	})
				// 	setProductsList(updatedProductsList)
				// }
				setSellerData(eachSeller)
				
			}
			
			return eachSeller
		})
	}

	const handleOnAddProduct = () => {
		const newProduct = {
			id: uuid(),
			pettyCashCategoryId: "",
			prodDesc: "",
			unit: 0,
			HSNCode: 0,
			TDS: 0,
			unitPrice: 0,
			quantity: 0,
			CGST: 0,
			SGST: 0,
			IGST: 0,
			disabled: true,
			isDocNoMandatory: false
		}
		setProductsList([...productsList, newProduct])
	}

	const handleOnDeleteProduct = (id) => {
		const filteredProductsList = productsList.filter(eachProduct => eachProduct.id !== id)
		setProductsList([...filteredProductsList])
	}
	const handleProductChange = (id, name, value) => {		
		const updatedProductsList = productsList.map((eachProduct,index) => {
			if (eachProduct.id === id) {
				if(name === 'docNo'){
					if(value){
						return { ...eachProduct, [name]: parseInt(value), isDocNoMandatory: eachProduct.pettyCashCategoryId?.isDocNoMandatory ? eachProduct.pettyCashCategoryId?.isDocNoMandatory : null }
					}
					else{
						return { ...eachProduct, [name]: null, isDocNoMandatory: eachProduct.pettyCashCategoryId?.isDocNoMandatory ? eachProduct.pettyCashCategoryId?.isDocNoMandatory : null }
					}
				}
				return { ...eachProduct, [name]: value, isDocNoMandatory: eachProduct.pettyCashCategoryId?.isDocNoMandatory ? eachProduct.pettyCashCategoryId?.isDocNoMandatory : null }
			}
			return eachProduct
		})
		setProductsList([...updatedProductsList])
	}

	const handleOnResetProductsList = () => {
		setProductsList([initialProduct])
	}

	let minTransactionDate = null
    const currentDate = new Date();
    const currentDay = currentDate.getDate();
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();

    if (currentDay <= 3) {
        // If current day is 7th or before, set minDate to previous month's currentDay
        minTransactionDate = new Date(currentYear, currentMonth - 1, currentDay);
    } else {
        // If current day is after 7th, set minDate to current month's 1st day
        minTransactionDate = new Date(currentYear, currentMonth, 1);
    }

	return (
		<>
			<div className="add-expense">
				<div className="p-card">
					<div className="grid">
						<div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
							<DropDownField name="PMState" labelText="Procmart State" optionLabel="stateName" optionValue="stateId" options={statesData} errorMessage={formErrors.PMState} value={transactionDetails.PMState} onChange={(e) => handleChange(e)} />
						</div>
						<div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
							<DropDownField name="pettyCashType" labelText="Petty Cash Type" optionLabel="label" optionValue="value" options={pettyCashTypeData} errorMessage={formErrors.pettyCashType} value={transactionDetails.pettyCashType} onChange={(e) => handleChange(e)} />
						</div>
						<div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0 h-1rem" >
							<CalendarField labelText="Txn Date" name="transactionDate" value={transactionDetails.transactionDate} minDate={new Date(minTransactionDate)} maxDate={new Date()} errorMessage={formErrors.transactionDate} onChange={(e) => handleChange(e)} />
						</div>
						<div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
							<DropDownField name="documentType" labelText="Document Type" optionLabel="label" optionValue="value" options={documentTypeData} errorMessage={formErrors.documentType} value={transactionDetails.documentType} onChange={(e) => handleChange(e)} />
						</div>
						{
							(transactionDetails.documentType !== "VOUCHER" && transactionDetails.documentType) ?
								<>
									<div className="flex mt-4 ml-1">
										<div>
											<FileUpload mode="basic" name="inVoice" accept="image/pdf/*"  customUpload uploadHandler={(files) => fileUploadHandler(files, "PETTYCASH_EXPENSE")} auto chooseLabel="Upload INVOICE" />
										</div>
										<div className="flex flex-column">
										{
											transactionDetails?.documentPath?.map((eachDoc, index) => {
												return (
													// <div>
													// 	<p>{index+1}</p>
													// 	<a href={eachDoc} className="view-btn mr-3" target="_blank">View</a>
													// 	<a className="remove-btn" name="remove_invoice" onClick={(event) => removeExpenseRelatedCertificates(event, "documentPath", eachDoc)} >Remove</a>
													// </div>
													<li className="flex flex-wrap px-2 py-1" key={eachDoc}>
														<a className="view-btn mr-3">{`${index+1})`}</a>
														<a href={eachDoc} className="view-btn mr-3" style={{ textDecoration: "none"}} target="_blank">View</a>
														<a style={{cursor : "pointer"}} className="vendor-component-remove-btn" name="remove_invoice" onClick={(event) => removeExpenseRelatedCertificates(event, "documentPath", eachDoc)} >Remove</a>
													</li>
												)
											})
										}
										</div>
									{/* {
										(!transactionDetails.documentPath) ?
										<div>
											<FileUpload mode="basic" name="inVoice" accept="image/pdf/*"  customUpload uploadHandler={(files) => fileUploadHandler(files, "PETTYCASH_EXPENSE")} auto chooseLabel="Upload INVOICE" />
										</div>
										:
										<div>
											<a href={transactionDetails.documentPath} className="view-btn mr-3" target="_blank">View</a>
											<a className="remove-btn" name="remove_invoice" onClick={(event) => removeExpenseRelatedCertificates(event, "documentPath")} >Remove</a>
										</div>
									} */}
									</div>
								</> : null
						}	
						
					</div>
				</div>
				<div className="p-card">
					<Button className="h-2rem  p-2" label="ASSIGN SELLER" onClick={() => setVisibleAssignSeller(true)} />
					{
						sellerData.name && 
						<div> <p> {sellerData.name} | {sellerData.emailId} | {sellerData.companyName} | {sellerData.branchName} </p></div>
					}
					</div>
				{
					productsList.map((eachProduct, index) => {
						//eachProduct = {...eachProduct, disabled: true}
						return (
							<div key={eachProduct.id}>
								<Product index={index} error={productErrors} transactionDetails={transactionDetails} sellerData={sellerData} pettyCashCategories={pettyCashCategories} UOMData={UOMData} handleProductChange={handleProductChange} product={eachProduct}  handleOnDeleteProduct={handleOnDeleteProduct} />
							</div>
						)
					})
				}
				<Loading visible={isLoading}/>
				<div className="flex flex-row justify-content-between add-reset-buttons">
					<Button className="h-2rem p-2 font-normal" label="ADD PRODUCT" outlined onClick={handleOnAddProduct} />
					{/* <div className="flex justify-content-center h-full">
						<ThreeDots height="50" width="50" radius="5"color="#00baac" ariaLabel="three-dots-loading" visible={isLoading} /> 
					</div> */}
					<Button className="h-2rem p-2" label="RESET PRODUCTS" outlined onClick={handleOnResetProductsList} />
				</div>
				<div className="flex flex-row justify-content-end mt-4">
					<h5 style={{ color: "#26a69a" }}>Total Price : {total}</h5>
				</div>
				<div className="flex flex-row justify-content-end mt-4">
					<Button className="h-2rem  p-2" label="ADD EXPENSE" onClick={handleOnAddExpense} />
				</div>
				<SellerSearch header = "Assign Seller" visible={visibleAssignseller} onHide={()=> setVisibleAssignSeller(false)} handleOnAddSeller={handleOnAddSeller} sellerSuggestions={sellerSuggestions} />
			</div>
		</>
	)
}
export default AddExpense;